<template>
    <el-dialog :title="$t('COMMON_EDIT')"
               visible
               width="55%"
               custom-class="site-admin-dialog"
               @close="onCancel">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="150px"
               label-position="top"
               v-loading="initAdInfoLoading"
               class="demo-ruleForm">
          <el-form-item v-if="!isArray" :label="nameFlag === 'owner' ? $t('PAGE_KPMG_TEAM_OWNER') : $t('FORM_LABEL_siteAdmin')"
                      prop="adminName">
              <select-ad
                          ref="selectAdd"
                          v-model="ruleForm.adminName"
                          :showAdd="false"
                          :api="selectFromAD"
                          :filter="adFilter"
                          size="small"
                          :collapseTags="false"
                          :onChanage="onAddAccount">
              </select-ad>
          </el-form-item>
        <!-- 站点管理员 -->
          <template v-else>
              <el-form-item :label="$t('ADD_FORM_LABEL_siteAdmin')" required>
                  <div class="__show-title">
                      <el-select
                          v-model="currentSelectUser"
                          filterable
                          clearable
                          remote
                          :placeholder="$t('searchPlaceholder')"
                          :remote-method="debounceFn"
                          value-key="staffNo"
                          class="select-ad"
                          :loading="loading">
                          <el-option
                              v-for="item in adUserListOpts"
                              :key="item.userAccount"
                              :label="item.userName + '(' + item.profitCenter + ')'"
                              :value="item">
                          </el-option>
                      </el-select>
                      <div class="__add-btn" @click="handleAdd">
                          <i class="el-icon-plus" style="margin-right: 2px;"></i>
                          {{ $t('btn_add') }}
                      </div>
                  </div>
              </el-form-item>
              <el-form-item :label="$t('FORM_LABEL_siteAdminCustom')" prop="adminName">
                  <div class="__show-content">
                      <transition-group name="fade" class="__inner">
                          <span v-for="item in siteAdminAdInfoList" :key="item.staffNo" class="__user-item">
                              {{ item.userName }}({{item.profitCenter}})
                              <i @click="onRemove(item)" class="el-icon-delete"></i>
                          </span>
                      </transition-group>
                  </div>
              </el-form-item>
          </template>
      </el-form>
  
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="onCancel"
                   class="cancel-btn">{{$t('comment_reSet')}}</el-button>
        <el-button type="primary"
                   @click="onConfirm"
                   class="wl-green">{{$t('btn_save')}}</el-button>
      </span>
    </el-dialog>
  </template>
  <script>
  import SelectAd from '@/components/common/selectAd';
  import API from '@/api';
  import * as _ from "lodash"
  
  export default {
      data() {
          return {
              ruleForm: {
                  adminName: '',
                  adminNameArry: ''
              },
              userData: '',
              // 站点管理员的一些变量
              loading: false,
              currentSelectUser: null,
              adUserListOpts: [],
              initAdInfoLoading: false,
              siteAdminAdInfoList: [],
          };
      },
      computed: {
          rules() {
              const rules = {
                  adminName: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }],
                  adminNameArry: [{ required: true, message: this.$t('FORM_VALIDATE_REQUIRED'), trigger: 'blur' }]
              }
              return rules
          }
      },
      methods: {
          onConfirm() {
              if (!this.isArray) {
                  this.userData = this.$refs['selectAdd'].getOptionValue();
              } else {
                  this.ruleForm.adminName = 'sb';
                  this.userData = this.siteAdminAdInfoList
              }
              this.$refs.ruleForm.validate(validate => {
                  if (validate) {
                      this.onAdd(this.userData);
                  }
              });
          },
          selectFromAD: params => API.system.adList(params),
          adFilter: v => Object.assign({}, v, { label: v.userName + '  (' + v.profitCenter + ')', value: v.userAccount }),
          onAddAccount(list) {},
          debounceFn: _.debounce(function (query) {
              this.realRemoteMethod(query)
          }, 800),
          async realRemoteMethod(query) {
              try {
                  this.loading = true
                  const list = await this.remoteMethod(query);
                  this.adUserListOpts = list;
              } catch (error) {
                  this.adUserListOpts = [];
              } finally {
                  this.loading = false
              }
          },
          async remoteMethod(query) {
              try {
              const {code, data, errDetails} = await API.system.adList({searchContent: query})
              if (code !== '1') throw new Error(errDetails)
              return Promise.resolve(data.records)
              } catch (e) {
              return Promise.reject([])
              }
          },
          async getADUserInfoByUserName() {
              const apiFuncList = this.ruleForm.adminNameArry.map(v => this.remoteMethod(v))
              this.initAdInfoLoading = true
              Promise.all(apiFuncList).then(res => {
                  const data = res.map(v => v[0])
                  this.siteAdminAdInfoList = data || []
              }).catch(() => {
                  this.$message.error('获取KP用户信息失败')
                  this.siteAdminAdInfoList = []
              })
              .finally(() => {
                  this.initAdInfoLoading = false
              })
          },
  
          onRemove(item) {
              const _index = this.siteAdminAdInfoList.findIndex(v => v.userAccount === item.userAccount)
              this.siteAdminAdInfoList.splice(_index, 1)
          },
          handleAdd() {
              if (!this.currentSelectUser) {
                  this.$message.warning('请先选择用户')
                  return
              }
              const isExist = this.siteAdminAdInfoList.some(v => v.userAccount === this.currentSelectUser.userAccount)
              if (!isExist) {
                  this.siteAdminAdInfoList.push(this.currentSelectUser)
                  this.$nextTick(() => {
                      this.currentSelectUser = null
                      this.adUserListOpts = []
                  })
              } else {
                  this.$message.warning('该用户已存在')
              }
              
          },
      },
      components: {
          SelectAd
      },
      mounted() {
          if (this.isArray) {
              let nameList = [];
              this.initData.forEach((i, n) => {
                  nameList.push(i.userAccount);
              });
              this.ruleForm.adminNameArry = nameList;
              this.getADUserInfoByUserName()
          } else {
              this.ruleForm.adminName = this.initData.userAccount;
          }
      },
      props: {
          isArray: Boolean,
          onAdd: Function,
          onCancel: Function,
          saveLoading: Boolean,
          initData: [String, Array],
          nameFlag: String
      }
  };
  </script>
  
  <style scoped>
  
  ::v-deep .site-admin-dialog .el-dialog__body {
      padding: 20px !important;
  }
  
  ::v-deep .site-admin-dialog .__show-title {
      display: flex;
  }
  
  ::v-deep .site-admin-dialog .select-ad {
      width:100%;
  }
  ::v-deep .site-admin-dialog .__add-btn {
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      background-color: #f0f3f8;
      flex-shrink: 0;
      color: #00338d;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      position: relative;
      right: 2px;
  }
  
  ::v-deep .site-admin-dialog .__show-content {
      padding: 10px 2px 2px 10px;
      border: 1px solid #e4e7ed;
      border-radius: 5px;
  }
  ::v-deep .site-admin-dialog .__show-content .__inner {
      display: flex;
      flex-wrap: wrap;
  }
  ::v-deep .site-admin-dialog .__show-content .__user-item {
      border-radius: 5px;
      background-color: #00348d0f;
      color: #00338d;
      font-size: 12px;
      padding: 1px 8px;
      margin-right: 8px;
      margin-bottom: 8px;
      transition: all 0.3s;
  }
  ::v-deep .site-admin-dialog .__show-content .__user-item i {
      cursor: pointer;
      margin-left: 3px;
      color: #F56C6C;
  }
  
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  </style>
  